import { render, staticRenderFns } from "./footer-area.vue?vue&type=template&id=7b72b47b&scoped=true&"
import script from "./footer-area.vue?vue&type=script&lang=js&"
export * from "./footer-area.vue?vue&type=script&lang=js&"
import style0 from "./footer-area.vue?vue&type=style&index=0&id=7b72b47b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b72b47b",
  null
  
)

export default component.exports